import axios from "config/axios/base";
import qs from "qs";

export const postRegister = ({ body = {}, options = null }) => axios.post("/auth/register", body, options);
export const postLogin = ({ body = {}, options = null }) => axios.post("/auth/login", body, options);
// New 2FA code for the login waiting for it: body { challenge_token } from the first /auth/login step.
export const postLoginResendCode = ({ body = {}, options = null }) =>
	axios.post("/auth/login/resend-code", body, options);
export const postLogout = ({ body = {}, options = null }) => axios.post("/auth/logout", body, options);
export const postMe = ({ body = {}, options = null }) => axios.post("/auth/me", body, options);
export const postResetPassword = ({ body = {}, options = null }) => axios.post("/auth/password/reset", body, options);
export const postSetPassword = ({ body = {}, options = null }) => axios.post("/auth/password/set", body, options);
export const postResetPasswordSendEmail = ({ body = {}, options = null }) =>
	axios.post("/auth/password/email", body, options);
export const loginByEmail = ({ body = {}, options = null }) => axios.post("/auth/loginByEmail", body, options);
export const getRecognizedDevices = ({ query = {}, options = null }) =>
	axios.get(`/auth/recognized-devices?${qs.stringify(query)}`, options);
export const deleteRecognizedDevice = ({ params = {}, options = null }) =>
	axios.delete(`/auth/device/delete/${params?.id}`, options);
export const postMobileVerification = ({ body = {}, options = null }) =>
	axios.post("/auth/verification/mobile", body, options);
export const postEmailVerification = ({ body = {}, options = null }) =>
	axios.post("/auth/verification/email", body, options);
/** Supports `apiHandler` shape `{ options: AxiosRequestConfig }` or a plain axios config object. */
export const getCountData = (payload = null) => {
	if (payload == null || typeof payload !== "object") {
		return axios.get("/auth/count-data", {});
	}
	const config = payload.options != null && typeof payload.options === "object" ? payload.options : payload;
	return axios.get("/auth/count-data", config);
};
